"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.squadronSchema = void 0;
const yup = __importStar(require("yup"));
const time_zone_enum_1 = require("../../enums/time-zone.enum");
const user_1 = require("../user");
const aircrew_composition_1 = require("./aircrew-composition");
const point_of_contact_1 = require("./point-of-contact");
const information_1 = require("./information");
exports.squadronSchema = yup.object().shape({
    id: yup.string().notRequired(),
    name: yup.string().notRequired(),
    mds: yup.string().notRequired(),
    createdAt: yup.number().required(),
    sortByPocName: yup.string(),
    searchKeys: yup.array().of(yup.string()),
    aircrewComposition: aircrew_composition_1.aircrewCompositionSchema,
    pointOfContact: point_of_contact_1.pointOfContactSchema,
    isActive: yup.boolean().required(),
    users: yup
        .array()
        .of(yup.object().shape({ user: user_1.userSchema }))
        .notRequired(),
    harmLocation: yup.string().max(20).notRequired(),
    timeZone: yup.string().oneOf(Object.keys(time_zone_enum_1.TimeZoneType)).notRequired(),
    enabledRating: yup.boolean().notRequired(),
    pocName: yup.string().notRequired(),
    information: information_1.squadronInformationSchema.notRequired(),
    wing: yup.string().notRequired(),
    group: yup.string().notRequired(),
});
